import React, { useState, useEffect } from "react";
import TwoStepVerificationOTP from "./TwoStepVerificationOTP";
import MfaVerification from "./MfaVerification";
import LoginWithOtpForm from "./LoginWithOtpForm";


const LoginWithOtp = ({ mobileNo, onCancelClick }) => {
    const [mfaVerifyEmail, setMFAVerifyEmail] = useState("");
    const [OTPVerifyMobileNo, setOTPVerifyMobileNo] = useState("");
    const [mfaUserId, setMfaUserId] = useState("");

    const [currentState, setCurrentState] = useState("");

    const onNextClick = (nextState) => {
        setCurrentState(nextState);
    };

    const currentComponet = () => {
        switch (currentState) {
            case "verify2Step":
                return (
                    <TwoStepVerificationOTP
                        mobileNo={OTPVerifyMobileNo}
                        onCancelClick={() => onNextClick("")}
                    />
                );
            case "verifyMFA":
                return (
                    <MfaVerification
                        email={mfaVerifyEmail}
                        mfaUserId={mfaUserId}
                        onNextClick={(msg) => onNextClick("")}
                    />
                );

            default:
                return (
                    <LoginWithOtpForm
                        onNextClick={(msg) => onNextClick(msg)}
                        mobileNo={mobileNo}
                        setMfaUserId={setMfaUserId}
                        setMFAVerifyEmail={setMFAVerifyEmail}
                        setOTPVerifyMobileNo={setOTPVerifyMobileNo}
                        onCancelClick={() => onCancelClick()}
                    />
                );
        }
    }

    return (
        <>
            {currentComponet()}
        </>
    )
}

export default LoginWithOtp;